export var checkBuildingInProduction = function (path) { return function (action, state$) {
    var building = action.building;
    if (building.production) {
        return path;
    }
    return undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/checks/checkBuildingInProduction.ts
// module id = 2071
// module chunks = 3